import React from "react";
import MyRouter from "routers/index";
import { AppProvider } from "./AppContext";
import { ToastContainer } from 'react-toastify';


function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200">
      <AppProvider>
        <MyRouter />
      </AppProvider>
      <ToastContainer position="top-right" autoClose={2000}  pauseOnHover/>
    </div>
  );
}

export default App;
